import { StatCard } from '../StatCard';

interface HeartRateStatsProps {
  min: number;
  avg: number;
  max: number;
}

export const HeartRateStats = ({ min, avg, max }: HeartRateStatsProps) => {
  return (
    <div className="grid grid-cols-3 gap-4">
      <StatCard
        title="Min Heart Rate"
        value={min}
        unit="BPM"
        subtitle="Lowest heart rate recorded"
        variant="blue"
      />

      <StatCard
        title="Avg Heart Rate"
        value={avg}
        unit="BPM"
        subtitle="Average heart rate over the day"
        variant="purple"
      />

      <StatCard
        title="Max Heart Rate"
        value={max}
        unit="BPM"
        subtitle="Highest heart rate recorded"
        variant="red"
      />
    </div>
  );
};
